import { useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "../../../constants/queryKeys";
import { EngineEarsError } from "../../../store/actions/errorStore";
import { ReleaseTrack } from "../../../store/models/release";
import { fetchReleaseTracks } from "../releaseAPI";

export const useFetchReleaseTracksQuery = (releaseId: number) => {
  return useQuery({
    queryKey: [QUERY_KEYS.FETCH_ARTIST_RELEASE_TRACKS, releaseId],
    queryFn: async () => {
      const response = await fetchReleaseTracks(releaseId);
      if (!response.success) {
        throw response.resultJson as EngineEarsError;
      }
      return response.resultJson as ReleaseTrack[];
    },
    retry: 0,
    enabled: Boolean(releaseId),
  });
};
